// components/HomePage/components/AIAgent/index.js
// Registry for AI agent components

import AIConversation from "./AIConversation";

// Map a subsection slug (subsection_url) to a specific agent component.
// Add more agents here as you build them, e.g.:
//   story_coach: StoryCoach,
//   resume_helper: ResumeHelper,
export const aiRegistry = {
  // Default fallback agent
  default: AIConversation,
};

